import React from 'react';

class Footer extends React.Component {
    render() {
        const year = new Date().getFullYear();
        
        return (
            <div className="footer">
                <div>
                    <strong>Copyright</strong> Babel Ops Ltd &copy; {year}
                </div>
            </div>
        )
    }
}

export default Footer